import { bloomScale } from "../../lib/questions";
import { QuestionStepShell } from "./QuestionStepShell";
import type { QuestionStepProps } from "./types";

/** Horizontale rij: alle opties naast elkaar, direct kiezen. */
export function QuestionStepSlider({
  question,
  questionIndex,
  totalQuestions,
  selectedValue,
  onSelect,
  onBack,
  canGoBack,
}: QuestionStepProps) {
  return (
    <QuestionStepShell
      question={question}
      questionIndex={questionIndex}
      totalQuestions={totalQuestions}
      selectedValue={selectedValue}
      onSelect={onSelect}
      onBack={onBack}
      canGoBack={canGoBack}
    >
      <div className="bloom-row" role="group" aria-label="Antwoordopties">
        {bloomScale.labels.map((label, index) => (
          <button
            key={index}
            type="button"
            className={`bloom-row__item${selectedValue === index ? " bloom-row__item--selected" : ""}`}
            aria-pressed={selectedValue === index}
            onClick={() => onSelect(index)}
          >
            {label}
          </button>
        ))}
      </div>
    </QuestionStepShell>
  );
}
